import { requestWithToken } from "../helper/helper";

const getComplaintsList = async (pageSize, pageNo, status) => {
  try {
    const response = await requestWithToken(
      "GET",
      `/complaints/list?pageNo=${pageNo}&pageSize=${pageSize}&status=${status}`
    );
    return response.data;
  } catch (err) {
    return err.response.data;
  }
};

const getComplaintsHistoryList = async (pageSize, pageNo, parentId) => {
  try {
    const response = await requestWithToken(
      "GET",
      `/complaints/childList?pageNo=${pageNo}&pageSize=${pageSize}&parentId=${parentId}`
    );
    return response.data;
  } catch (err) {
    return err.response.data;
  }
};
const compaintStatusUpdate = async (id, payload) => {
  try {
    const response = await requestWithToken(
      "PUT",
      `/complaints/status/${id}`,
      payload
    );

    return response.data;
  } catch (err) {
    return err.response.data;
  }
};
const complaintAddComment = async (payload) => {
  try {
    const response = await requestWithToken(
      "POST",
      `/complaintComment`,
      payload
    );

    return response.data;
  } catch (err) {
    return err.response.data;
  }
};
const UpdateComment = async (id, payload) => {
  try {
    const response = await requestWithToken(
      "PUT",
      `/complaintComment/${id}`,
      payload
    );

    return response.data;
  } catch (err) {
    return err.response.data;
  }
};
const complaintCount = async (startDate, endDate) => {
  try {
    const response = await requestWithToken(
      "GET",
      `/complaints/status-count?startDate=${startDate}&endDate=${endDate}`
    );

    return response.data;
  } catch (err) {
    return err.response.data;
  }
};
const DeleteComment = async (id) => {
  try {
    const response = await requestWithToken(
      "DELETE",
      `/complaintComment/${id}`
    );

    return response.data;
  } catch (err) {
    return err.response.data;
  }
};
const fetchCommentList = async (pageNo, pageSize, id) => {
  try {
    const response = await requestWithToken(
      "GET",
      `/complaintComment/list?pageNo=${pageNo}&pageSize=${pageSize}&complaintId=${id}`
    );

    return response?.data;
  } catch (err) {
    return err?.response?.data;
  }
};

export {
  getComplaintsList,
  compaintStatusUpdate,
  getComplaintsHistoryList,
  complaintAddComment,
  UpdateComment,
  DeleteComment, fetchCommentList,
  complaintCount
};
